import React, {Dispatch, SetStateAction} from 'react';
import COMPATIO_LOGO from '../../../../../../assests/img/compatio_logo_without_name.png';
import {BackIcon, EditIcon} from 'assests/GmsIcons';
import {UIModelAPI} from "../../types/api.types";
import {useModule} from "../../contexts/ModuleContext";
import {toast} from "react-toastify";
import { useComponentRegistry } from '../../contexts/ComponentRegistryContext';
import { useEditor } from '../../contexts/EditorContext';
import {useVerticalNav} from "../../hooks/useVerticalNav";
import { useUIModelApi } from "../../contexts/UIModelApiContext";

type EditorHeaderProps = {
    id?: string;
    uiModel: UIModelAPI | null;
    setShowCreateUiModel: Dispatch<SetStateAction<boolean>>
    onPreviewPressed: () => void;
}

export const EditorHeader = ({id, uiModel, setShowCreateUiModel, onPreviewPressed} : EditorHeaderProps) => {
  const baseId = id || 'editor-header';
  const {setActiveView, hasEditPermission} = useModule();
  const { resetRegistry } = useComponentRegistry();
  const { setEditorState, setContainers, setGroups } = useEditor();
  const {setActiveTab} = useVerticalNav();
  const {
    setHeaderConfig,
    setFooterConfig,
    setNavigationConfig,
    setHeaderLogoFile,
    setHeaderResetIconFile,
    setHeaderCloseIconFile,
    setFooterPreviousIconFile,
    setFooterNextIconFile,
    setCanvasMap,
    setCanvas
  } = useUIModelApi();

  const handleBackClick = () => {
    resetRegistry();
    setActiveTab('layout');
    setEditorState({
      activeGroupId: null,
      activePageId: null,
      selectedContainerId: null,
      selectedFieldId: null,
      selectedFieldType: null,
      selectedFieldParentId: null,
      selectedSubmodelId: null,
      selectedWidgetId: null,
      selectedWidgetType: null,
      componentUsage: {},
      componentRegistry: {
        subModels: {},
        widgets: {}
      },
      fieldConfigurations: {},
      selectionPath: [],
    });

    setContainers({});

    setGroups([]);

    // Clear UIModelApi state for header, footer, navigation, and canvas
    setHeaderConfig(null);
    setFooterConfig(null);
    setNavigationConfig(null);
    setHeaderLogoFile(null);
    setHeaderResetIconFile(null);
    setHeaderCloseIconFile(null);
    setFooterPreviousIconFile(null);
    setFooterNextIconFile(null);
    setCanvasMap({});
    setCanvas({});

    setActiveView('list');
  };

  return (
    <div id={baseId} data-testid={baseId} className="tw-p-1 tw-border-b tw-bg-[#F4F4F7] tw-border-[#E5E5EA]">
      <div id={`${baseId}-content`} className='tw-flex tw-justify-between tw-items-center'>
        <div id={`${baseId}-left-section`} className="tw-flex tw-items-center tw-space-x-2">
            <div id={`${baseId}-back-btn`} data-testid={`${baseId}-back-btn`} onClick={handleBackClick} className="tw-cursor-pointer">
              <BackIcon />
            </div>
            <img id={`${baseId}-icon`} src={uiModel?.launchIcon || COMPATIO_LOGO} alt="Launcher Icon" loading='lazy' className="tw-w-8 tw-h-8 tw-rounded tw-border tw-border-[#969fae]" />
            <h2 id={`${baseId}-title`} className="tw-text-[#172B4D] tw-text-base tw-font-semibold">{uiModel?.name}</h2>
            <button
                id={`${baseId}-edit-btn`}
                data-testid={`${baseId}-edit-btn`}
                onClick={() => {
                    if (!hasEditPermission()) {
                        toast.error('You dont have permission to update this model')
                        return;
                    }
                    setShowCreateUiModel(true);
                }}
            >
                <EditIcon/>
            </button>
        </div>
          <button
              id={`${baseId}-preview-btn`}
              data-testid={`${baseId}-preview-btn`}
              className="samll-outline-btn"
              onClick={onPreviewPressed}
          >Preview
          </button>
      </div>
    </div>
  );
};